 const product=[





{ 
    img:"./thedata/mixDry.png",
    name:"Premium Dry Fruits Mix",
    descrption: "Enjoy the natural crunch and sweet-savory balance of cashews, almonds, green kishmish, and in-shell pistachios." ,
    price : 700,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},

{ 
    img:"./thedata/mixBerryDry.png",
    name:"Premium Dry Fruits & Berries Mix",
    descrption: "Enjoy a delicious balance of textures and natural sweetness with crunchy cashews and almonds, and juicy bursts of raisins, cranberries, and blueberries." ,
    price : 850,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},

 
{ 
    img:"./thedata/w320.png",
    name:"Cashew (Kaju) Medium",
    descrption: "Rich in healthy fats, perfect for snacking or cooking. Soft, crunchy, and creamy." ,
    price :"600",
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},
{ 
    img:"./thedata/w210.png",
    name:"Cashew (Kaju) Large",
    descrption: "Rich in healthy fats, perfect for snacking or cooking. Soft, crunchy, and creamy." ,
    price : 750,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},

{ 
    img:"./thedata/w180.png",
    name:"Cashew (Kaju) Jumbo",
    descrption: "Rich in healthy fats, perfect for snacking or cooking. Soft, crunchy, and creamy." ,
    price : 900,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},
{ 
    img:"./thedata/kishmishGreenAfgani.png",
    name:"Raisins (Kishmish) - Green Afgani",
    descrption: "Naturally sweet and chewy. Great for digestion and energy." ,
    price : 550,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},{ 
    img:"./thedata/kishmishYellowIndian.png",
    name:"Raisins (Kishmish) - Long Yellow Indian",
    descrption: "High-energy yellow kishmish with natural sweetness." ,
    price : 550,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},{ 
    img:"./thedata/kishmishYellowSmall.png",
    name:"Raisins (Kishmish) - Short Yellow Indian",
    descrption: "Naturally sweet and chewy. Great for digestion and energy." ,
    price : 500,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},{ 
    img:"./thedata/kishmishBlackAfgani.png",
    name:"Raisins (Kishmish) - Black Afgani",
    descrption: "Chewy, sweet raisins with natural seeds." ,
    price : 400,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},{ 
    img:"./thedata/almondInde.png",
    name:"Almonds (Badam) - California Regular (Without Shell)",
    descrption: "High in protein & vitamin E. Ideal for daily consumption and boosting memory." ,
    price : 500,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},{ 
    img:"./thedata/almondCali.png",
    name:"Almonds (Badam) - California Premium (Without Shell)",
    descrption: "High in protein & vitamin E. Ideal for daily consumption and boosting memory." ,
    price : 600,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},
{ 
    img:"./thedata/badamAbdulwahid.png",
    name:"Almonds - Afghani With Shell",
    descrption: "Whole almonds in shell, traditional and fresh." ,
    price : 500,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},
{ 
    img:"./thedata/badamGola.png",
    name:"Almonds - California With Shell",
    descrption: "Whole almonds in shell, traditional and fresh." ,
    price : 600,
    weight:"1kg",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},
{ 
    img:"./thedata/pistaCali.png",
    name:"Pistachios (Pista) - California ",
    descrption: "Crunchy and flavorful with a salty kick. Excellent for snacks or gifting. Rich in antioxidants." ,
    price : 800,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},{ 
    img:"./thedata/pistaIran.png",
    name:"Pistachios (Pista) - Iranian ",
    descrption: "Crunchy and flavorful with a salty kick. Excellent for snacks or gifting. Rich in antioxidants." ,
    price : 800,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},


{    img:"./thedata/figAfgani.png",
name:"Figs - Dried Afghani Anjeer",
descrption: "Chewy, premium figs with bold natural flavor." ,
price : 850,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:true
},

{    img:"./thedata/figTurkey.png",
name:"Figs - Dried Turkish Anjeer",
descrption: "Soft, juicy figs rich in antioxidants." ,
price : 850,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:true
},

{ 
    img:"./thedata/macNut.png",
    name:"Macadamia Nuts in Shell - Roasted",
    descrption: "Buttery, rich, heart-healthy nuts." ,
    price : 950,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},


{    img:"./thedata/brazilNut.png",
  "name": "Brazil Nuts - Premium",
  "description": "Rich, buttery, and nutrient-dense. A delicious source of selenium and healthy fats.",
  "price": 950,
  "weight": "500gm",
  "category": "Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:true
},

{ 
    img:"./thedata/pineNut.png",
    name:"Pine Nuts (Chilgoza) - Premium",
    descrption: "Buttery, rich, heart-healthy nuts." ,
    price : 1250,
    weight:"250gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},



{    img:"./thedata/foxNut.png",
name:"Fox Nuts (Makhana) - Roasted",
descrption: "Light and crisp, ideal for fasting." ,
price : 700,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:true
},

{ 
    img:"./thedata/pecanNut.png",
    name:"Pecan Nuts in Shell - Roasted ",
    descrption: "Sweet and nutty, rich in antioxidants." ,
    price : 950,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},
{    img:"./thedata/hazelnut.png",
name:"Hazelnuts - Roasted Whole",
descrption: "Crunchy and mildly sweet, perfect snack." ,
price : 1200,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:true
},

{ 
    img:"./thedata/appricotTurkey.png",
    name:"Apricots (Khubani) - Dried Turkish",
    descrption: "Juicy, sweet dried fruit rich in vitamin A." ,
    price : 950,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},{ 
    img:"./thedata/appricotLadakh.png",
    name:"Apricots (Khubani) - Dried Ladakhi",
    descrption: "Sweet and tangy Ladakhi dried apricots, naturally sun-dried and rich in flavor." ,
    price : 750,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:true
},
{    img:"./thedata/chocoDry.png",
name:"Chocolate Coated Dry Fruits - Mix",
descrption: "Flavored choco-coated nuts & raisins combo." ,
price : 650,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:true
},




{    img:"./thedata/blueberry.png",
name:"Blueberries - Dried Whole",
descrption: "Antioxidant-rich dried berries for brain." ,
price : 1300,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:true
},
{    img:"./thedata/cranberry.png",
name:"Cranberries - Dried Sweetened",
descrption: "Tart and sweet, supports urinary health." ,
price : 700,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:true
},

{ 
    img:"./thedata/kiwi.png",
    name:"Kiwi - Dried Slices",
    descrption: "Tangy-sweet dried kiwi, colorful and tasty." ,
    price : 450,
    weight:"500gm",
    category:"Dry Fruits & Nuts",
    outOfStock:false,
    onHome:true,
    onOffer:false
},


{    img:"./thedata/mango.png",
name:"Mango - Dried Slices",
descrption: "Sweet and chewy, summer favorite in dried form." ,
price : 450,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:false
},

{    img:"./thedata/pineapple.png",
name:"Pineapple - Dried Rings",
descrption: "Juicy, tropical taste in every bite." ,
price : 450,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:false
},

{    img:"./thedata/tutyfuty.png",
name:"Tutti Frutti - Mixed Colored Cubes",
descrption: "Sweetened papaya chunks, used in cakes and sweets." ,
price : 400,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:true
},

{    img:"./thedata/cherry.png",
name:"Cherries - Dried & Sweetened",
descrption: "Tangy and sweet, great in salads or baking." ,
price : 550,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:false
},




{    img:"./thedata/roseberry.png",
name:"Roseberry - Dried",
descrption: "Tart, sweet , semi-dried berry." ,
price : 550,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:false
},

{    img:"./thedata/straberry.png",
name:"Strawberries - Sugar-Boiled",
descrption: "Sweet, soft, sugar-coated strawberry slices." ,
price : 500,
weight:"500gm",
category:"Dry Fruits & Nuts",
outOfStock:false,
onHome:true,
onOffer:false
},






{    img:"./thedata/mixSeedDry.png",
name:"Premium Seeds Mix",
descrption: "Perfect for your morning bowl or on-the-go! Enjoy the energy and goodness of chia, flax, pumpkin, and white sunflower seeds alongside rich cashews, crisp almonds, and juicy raisins." ,
price : 550,
weight:"500gm",
category:"Seeds",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/mixSeed.png",
name:"Mixed Seeds",
descrption: "A power-packed blend of chia, flax, pumpkin, and sunflower seeds, offering a delightful crunch and a wealth of omega-3s, fiber, and protein." ,
price : 400,
weight:"500gm",
category:"Seeds",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/chia.png",
name:"Chia Seeds",
descrption: "Tiny, black or white seeds that form a gel when soaked. Rich in omega-3s and fiber. Great for puddings, smoothies." ,
price : 400,
weight:"500gm",
category:"Seeds",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/flex.png",
name:"Flax Seeds",
descrption: "Small, flat, brown or golden seeds. Best consumed ground for omega-3 and fiber absorption. Good for baking, cereals." ,
price : 300,
weight:"500gm",
category:"Seeds",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/pumpkin.png",
name:"Pumpkin Seeds",
descrption: "Flat, green, nutty seeds. High in magnesium and zinc. Excellent for snacking, salads, baking." ,
price : 500,
weight:"500gm",
category:"Seeds",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/sunflower.png",
name:"Sunflower Seeds",
descrption: "Mild, nutty seeds. Excellent source of Vitamin E. Popular for snacking, salads, and making seed butter." ,
price : 350,
weight:"500gm",
category:"Seeds",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/sesame.png",
name:"Sesame Seeds",
descrption: "Tiny, flat seeds (white, black). Nutty flavor, often toasted. Used as a garnish, in tahini, and baking." ,
price : 500,
weight:"500gm",
category:"Seeds",
outOfStock:false,
onHome:true,
onOffer:false
},






{    img:"./thedata/madjoul.jpg",
name:"Medjool Dates",
descrption: "The 'Queen of Dates' these are large, soft, and moist with a rich, caramel-like flavor." ,
price : 1600,
weight:"1kg",
category:"Dates",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/kalmi.png",
name:"Safawi/Kalmi Dates",
descrption: "A deep black, semi-dry date with a long shape, a moderately sweet taste, and a chewy texture." ,
price : 800,
weight:"1kg",
category:"Dates",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/mabroom.jpg",
name:"Mabroom Dates",
descrption: "A long, slender date with a firm texture, mild sweetness, and a reddish-brown color." ,
price : 1400,
weight:"1kg",
category:"Dates",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/ajwa.jpg",
name:"Ajwa Dates",
descrption: "Known as the 'King of Dates' these are small, dark, and soft with a sweet, prune-like flavor." ,
price : 1500,
weight:"1kg",
category:"Dates",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/sugai.jpg",
name:"Sugai Dates",
descrption: "Unique two-toned dates with a soft, golden top and a chewy, darker base and a mild sweetness." ,
price : 850,
weight:"1kg",
category:"Dates",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/sukkari.png",
name:"Sukkari Dates",
descrption: "Naturally sweet, slightly dry, and wonderfully soft, known for their rich taste and caramel-like flavor." ,
price : 850,
weight:"1kg",
category:"Dates",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/amber.png",
name:"Amber Dates",
descrption: "Large, soft, and richly sweet—Amber dates are known for their premium quality and energizing taste." ,
price : 1200,
weight:"1kg",
category:"Dates",
outOfStock:false,
onHome:true,
onOffer:false
},









{    img:"./thedata/acaciaHoney.png",
name:"Acacia Honey",
descrption: "A light and delicate honey with a mild, clean, floral taste, perfect for sweetening without overpowering." ,
price : 850,
weight:"500gm",
category:"Honey & Saffron",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/saffronKashmir5gm.png",
name:"Kashmiri Mongra Saffron",
descrption: "The finest saffron from Kashmir, known for its dark maroon threads, strong aroma, and vibrant coloring power." ,
price : 2000,
weight:"5gm",
category:"Honey & Saffron",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/blackHoney.png",
name:"Black Honey",
descrption: "A dark and robust honey with a rich, intense flavor and a slightly bitter, complex profile." ,
price : 800,
weight:"500gm",
category:"Honey & Saffron",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/saffronIran5gm.png",
name:"Irani Saffron Negin",
descrption: "Top-grade Iranian saffron with long, all-red threads, offering high coloring strength and a powerful aroma." ,
price : 1500,
weight:"5gm",
category:"Honey & Saffron",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/sidereHoney.png",
name:"Sidr Honey",
descrption: "A premium, golden honey with a rich aroma and distinctive, bold flavor, sourced from the wild jujube tree." ,
price : 850,
weight:"500gm",
category:"Honey & Saffron",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/saffronIran3gm.png",
name:"Irani Saffron Negin",
descrption: "Top-grade Iranian saffron with long, all-red threads, offering high coloring strength and a powerful aroma." ,
price : 1000,
weight:"3gm",
category:"Honey & Saffron",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/saffronKashmiri3gm.png",
name:"Kashmiri Mongra Saffron",
descrption: "The finest saffron from Kashmir, known for its dark maroon threads, strong aroma, and vibrant coloring power." ,
price : 1400,
weight:"3gm",
category:"Honey & Saffron",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/saffronIran1gm.png",
name:"Irani Saffron Negin",
descrption: "Top-grade Iranian saffron with long, all-red threads, offering high coloring strength and a powerful aroma." ,
price : 450,
weight:"1gm",
category:"Honey & Saffron",
outOfStock:false,
onHome:true,
onOffer:false
},
{    img:"./thedata/saffronKashmiri1gm.png",
name:"Kashmiri Mongra Saffron",
descrption: "The finest saffron from Kashmir, known for its dark maroon threads, strong aroma, and vibrant coloring power." ,
price : 650,
weight:"1gm",
category:"Honey & Saffron",
outOfStock:false,
onHome:true,
onOffer:false
},









{    img:"./thedata/fineR16.jpg",
name:"Round Basket - 16in.",
descrption: "Open round basket without handle. Diameter is 16in., height is 4in. suits kitchens, living spaces, or gifting." ,
price : 400,
weight:"1 Pc",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/handelJali16.jpg",
name:"Round Jali Basket with Handle - 16in.",
descrption: "Handwoven openwork round jali set of 3 with handle. Measures 16in. 14in. & 12in. diameter and 4in. height, perfect for fruits and bread." ,
price : 1200,
weight:"3 Pc",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/fineR18.jpg",
name:"Round Basket - 18in.",
descrption: "Multipurpose round basket, no handle, with an 18in. diameter and a 4in. height. Use for serving or display." ,
price : 550,
weight:"1 Pc",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/handleHeart14.jpg",
name:"Heart Basket with Handle - 14in.",
descrption: "Handwoven heart-shaped willow basket set of 3 with sturdy handle. Measures 14in. 12in. & 10in. diameter and 4in. height, perfect for gifting, décor, or small storage." ,
price : 900,
weight:"3 Pc",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/fineR20.jpg",
name:"Round Basket - 20in.",
descrption: "Generous, open round basket. Measures 20in. diameter and 4in. height, great centerpiece or for larger storage needs." ,
price : 700,
weight:"1 Pc",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/handelHex14.jpg",
name:"Hex Basket with Handle - 14in.",
descrption: "Compact hexagonal willow basket set of 3 with handle. Diameter is 14in. 12in. & 10in. and height is 4in. great for gifts or small storage." ,
price : 900,
weight:"3 Pc",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/fineRK22.jpg",
name:"Round Basket - 22in.",
descrption: "Large round basket with wavy upper edges and a 22in. diameter and 5in. height, without handle. Ideal for home organization or shop displays." ,
price : 850,
weight:"1 Pc",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/fineRK24.jpg",
name:"Round Basket - 24in.",
descrption: "Oversized handle-free round basket with wavy upper edges, 24in. diameter and 5in. height, perfect for markets or large storage." ,
price : 900,
weight:"1 Pc",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/hex16.jpg",
name:"Hex Basket - 16in.",
descrption: "Handwoven hexagonal basket, no handle, with 16in. diameter and 4in. height. Suits kitchen or décor uses." ,
price : 600,
weight:"1 Pcgm",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/hex18.jpg",
name:"Hex Basket - 18in.",
descrption: "Medium-size hex basket without handle. Measures 18in. diameter and 4in. height, great for organizing and display." ,
price : 750,
weight:"1 Pc",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/hex20.jpg",
name:"Hex Basket - 20in.",
descrption: "Functional hex basket, no handle, with 20in. diameter and 4in. height, perfect for home or shop use." ,
price : 850,
weight:"1 Pc",
category:"Kashmiri Fine Baskets",
outOfStock:false,
onHome:true,
onOffer:false 
},







{    img:"./thedata/walnutGiriSnow.png",
name:"Snow White Walnut Kernels",
descrption: "Premium Kashmiri walnuts, shelled to reveal their pristine, snow-white kernels. Delicate and buttery in flavor, they're perfect for gourmet baking or snacking." ,
price : 1650,
weight:"1kg",
category:"Kashmiri Dry Fruits",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/mamrah.jpg",
name:"Curved Mamrah Almond Kernels",
descrption: "Distinguished by their curved shape, these premium Kashmiri Mamrah almonds are shelled to deliver a rich, buttery flavor and high oil content." ,
price : 1850,
weight:"1kg",
category:"Kashmiri Dry Fruits",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/walnutGiriGold.png",
name:"Golden Walnut Kernels",
descrption: "Hand-picked and shelled, these premium Kashmiri walnuts have a rich, golden-brown hue and a robust, earthy flavor with a satisfying crunch." ,
price : 1200,
weight:"1kg",
category:"Kashmiri Dry Fruits",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/mamrahPlain.png",
name:"Mamrah Almond Kernels (Single Tree)",
descrption: "Sourced from a single tree, these premium Kashmiri Mamrah almonds are shelled to preserve their pure, unique flavor profile and exceptional quality." ,
price : 1450,
weight:"1kg",
category:"Kashmiri Dry Fruits",
outOfStock:false,
onHome:true,
onOffer:false 
},
{    img:"./thedata/walnutShell.png",
name:"Whole Walnuts (With Shell)",
descrption: "Premium whole Kashmiri walnuts, a classic and satisfying way to enjoy fresh, flavorful kernels." ,
price : 700,
weight:"1kg",
category:"Kashmiri Dry Fruits",
outOfStock:false,
onHome:true,
onOffer:false 
},





{   
videoUrl:"./thedata/catchment.mp4",
name:"Catchment Hampers",
descrption: "Our Catchment Hampers are crafted to spread sweetness and joy, featuring a Toffee Basket filled with assorted toffees, a Dry Fruit Basket/Tray packed with premium nuts and dried fruits, and a Sweet Box carrying traditional delicacies. Each hamper is beautifully arranged to suit every celebration, and customers can customize them further by choosing their preferred sweets, chocolates, or dry fruits to make the gift more personal. " ,
weight:"5gm",
category:"Hamper Packages",
outOfStock:false,
onHome:true,
onOffer:false
},
{   
videoUrl:"./thedata/nikah.mp4",
name:"Nikah Hampers",
descrption: "Celebrate the sacred bond of marriage with our Nikah Hampers, which include a Khajoor Dates Hamper carrying premium dates to symbolize blessings and prosperity, along with a Toffee Basket elegantly filled with assorted sweets. These hampers are a perfect token of love and joy, and can be customized with additional chocolates, dry fruits, or sweets according to your choice and tradition." ,
weight:"5gm",
category:"Hamper Packages",
outOfStock:false,
onHome:true,
onOffer:false
},
{   
videoUrl:"./thedata/mendhi.mp4",
name:"Mehndi Hampers",
descrption: "Add vibrance to your celebrations with our Mehndi Hampers, which feature a beautifully decorated Mehndi-Themed Basket/Tray, a sweet-filled Toffee Basket, and a rich Chocolate Basket. Perfect for sharing joy during Mehndi functions, these hampers can also be customized with your preferred mix of chocolates, dry fruits, or sweets to match the festive spirit and personal choice." ,
weight:"5gm",
category:"Hamper Packages",
outOfStock:false,
onHome:true,
onOffer:false
},
{   
videoUrl:"./thedata/engagement.mp4",
name:"Engagement Hampers",
descrption: "Our Engagement Hampers are designed to make your special day more memorable, offering a Toffee Basket paired with a Dry Fruit Tray/Basket, a Chocolate Basket complemented with a Dry Fruit Bowl, and a Sweet Box filled with traditional delights. Each basket is carefully packed for elegance and taste, and you can fully customize them with your selection of chocolates, nuts, or sweets to match the occasion perfectly." ,
weight:"5gm",
category:"Hamper Packages",
outOfStock:false,
onHome:true,
onOffer:false
},
{   
videoUrl:"./thedata/chocolate.mp4",
name:"Chocolate Hampers",
descrption: "For all chocolate lovers, our Chocolate Hampers bring the ultimate indulgence with a Chocolate Basket brimming with assorted premium chocolates, and Customized Chocolate Assortments that can be tailored with different flavors, brands, and designs. Whether for weddings, birthdays, or festive gifting, these hampers can be customized further with nuts, sweets, or dry fruits to create a truly delightful present." ,
weight:"5gm",
category:"Hamper Packages",
outOfStock:false,
onHome:true,
onOffer:false
},
{   
videoUrl:"./thedata/dryfruit.mp4",
name:"Dry Fruit Hampers",
descrption: "Healthy yet luxurious, our Dry Fruit Hampers include a Cashew Selection of finest quality nuts, along with a Mixed Dry Fruit Assortment containing almonds, raisins, pistachios, walnuts, and more, all presented in elegant trays, baskets, or boxes. These hampers are ideal for gifting at weddings, festivals, or corporate events, and can be fully customized with your choice of dry fruits, chocolates, or sweets in packaging of your preference." ,
weight:"5gm",
category:"Hamper Packages",
outOfStock:false,
onHome:true,
onOffer:false
},
{   
videoUrl:"./thedata/ramzan.mp4",
name:"Ramzan Hampers",
descrption: "Specially curated for the holy month, our Ramzan Hampers feature Cashews, Almonds, and a wide range of Dry Fruit Assortments including dates and apricots, beautifully packed to make Iftar and Eid even more special. Each hamper is arranged with care to symbolize sharing and blessings, and can be customized with your selection of nuts, sweets, or chocolates to create the perfect Ramadan gift for your loved ones." ,
weight:"5gm",
category:"Hamper Packages",
outOfStock:false,
onHome:true,
onOffer:false
},

]
export default product;